import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";

const CURATED_PALETTE = [
  { border: '#6366f1', bg: 'rgba(99, 102, 241, 0.10)' },
  { border: '#10b981', bg: 'rgba(16, 185, 129, 0.10)' },
  { border: '#f59e0b', bg: 'rgba(245, 158, 11, 0.10)' },
  { border: '#ef4444', bg: 'rgba(239, 68, 68, 0.10)' },
  { border: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.10)' },
  { border: '#06b6d4', bg: 'rgba(6, 182, 212, 0.10)' },
  { border: '#ec4899', bg: 'rgba(236, 72, 153, 0.10)' },
  { border: '#14b8a6', bg: 'rgba(20, 184, 166, 0.10)' },
];

const chartOptions = {
  maintainAspectRatio: false,
  legend: {
    position: 'bottom',
    labels: {
      usePointStyle: true,
      padding: 24,
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      fontSize: 12,
      fontStyle: '600',
      fontColor: '#64748b',
      boxWidth: 8,
    },
  },
  tooltips: {
    backgroundColor: '#0f172a',
    titleFontFamily: "'Inter', 'Segoe UI', sans-serif",
    titleFontSize: 13,
    titleFontStyle: '600',
    titleFontColor: '#f8fafc',
    bodyFontFamily: "'Inter', 'Segoe UI', sans-serif",
    bodyFontSize: 12,
    bodyFontStyle: '600',
    bodyFontColor: '#cbd5e1',
    cornerRadius: 12,
    xPadding: 16,
    yPadding: 14,
    displayColors: true,
    mode: 'index',
    intersect: false,
    borderColor: 'rgba(255,255,255,0.08)',
    borderWidth: 1,
    caretSize: 6,
  },
  scales: {
    xAxes: [{
      gridLines: {
        color: 'rgba(148, 163, 184, 0.05)',
        drawBorder: false,
        zeroLineColor: 'rgba(148, 163, 184, 0.08)',
      },
      ticks: {
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        fontSize: 11,
        fontStyle: '600',
        fontColor: '#94a3b8',
        padding: 10,
      },
    }],
    yAxes: [{
      gridLines: {
        color: 'rgba(148, 163, 184, 0.05)',
        drawBorder: false,
        zeroLineColor: 'rgba(148, 163, 184, 0.08)',
      },
      ticks: {
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        fontSize: 11,
        fontStyle: '600',
        fontColor: '#94a3b8',
        beginAtZero: true,
        padding: 12,
      },
    }],
  },
  elements: {
    line: {
      tension: 0.38,
      borderWidth: 3,
    },
    point: {
      radius: 0,
      hoverRadius: 6,
      hitRadius: 22,
      hoverBorderWidth: 3,
      hoverBackgroundColor: '#ffffff',
    },
  },
  hover: {
    mode: 'index',
    intersect: false,
  },
};

const LineChart = ({ graphData = [] }) => {
  const data = (canvas) => {
    if (!graphData || graphData.length === 0) {
      return { labels: [], datasets: [] };
    }

    const firstItem = graphData[0];
    const labels = [...(firstItem?.label || [])];
    const ctx = canvas.getContext("2d");

    const datasets = graphData.map((item, idx) => {
      const palette = CURATED_PALETTE[idx % CURATED_PALETTE.length];
      
      // Create modern visual gradient
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height || 260);
      gradient.addColorStop(0, `${palette.border}22`); // ~13% opacity at top
      gradient.addColorStop(0.5, `${palette.border}08`); // ~3% opacity at mid
      gradient.addColorStop(1, `${palette.border}00`);   // Transparent at bottom

      return {
        label: item?.type,
        fill: true,
        backgroundColor: gradient,
        borderColor: palette.border,
        pointBackgroundColor: palette.border,
        pointBorderColor: '#ffffff',
        pointHoverBackgroundColor: '#ffffff',
        pointHoverBorderColor: palette.border,
        data: [...(item?.data || [])],
      };
    });

    return { labels, datasets };
  };

  return (
    <div className="chart">
      <Line data={data} options={chartOptions} />
    </div>
  );
};


export default LineChart;
